import { actions } from "./slice";
export const addEmote = actions.add;
export const removeEmote = actions.remove;
